export * from './api/getMobileToken';
export * from './api/requestMobileToken';
export * from './api/createMobileToken';
export * from './api/updateMobileToken';
export * from './api/validateMobileToken';
export * from './types';

export const WRONG_TOKEN = 1;
export const WRONG_TOKEN_VALIDATION = 2;
